import React from "react";
import { Link } from "react-router-dom";
import ArticlesBy from "./ArticlesBy";
import NakedGun from "../src/grabbag-pictures/spoof-nielsen.webp";
import JuanjoPic from "../src/coldtake-pictures/juanjo1.png";
import Fade from "react-reveal/Fade";

function Juanjo() {
  return (
    <div>
      <div className="aboutWriterContainer">
        <div className="writerThumbnail">
          <img
            src={JuanjoPic}
            className="writerThumbnailImage"
            alt="writer-headshot"
          ></img>
        </div>
        <div className="nameAndBlurbContainer">
          <div className="writerName">Rayo Juanin</div>
          <div className="writerBlurb">
            Rayo is a sharp spark, alive with the fire of mezcal.
          </div>
        </div>
      </div>
      <div className="alsoWrittenByContainer">
        <p className="seeAlsoHeader">Articles by Rayo</p>
        <Fade bottom>
          <ArticlesBy
            picture={NakedGun}
            otherArticleTitle={"COMING SOON"}
            otherArticleSynopsis={"Rayo's pieces will soon be made available."}
          />
        </Fade>
      </div>
    </div>
  );
}

export default Juanjo;
